import { useEffect, useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import Logo from "./Logo";
import Icon from "./Icon";
import { navLinks } from "../data/content";
import { useSiteContent } from "../siteContent";

const linkClass = ({ isActive }) =>
  `whitespace-nowrap text-sm font-semibold transition-colors ${
    isActive
      ? "border-b-2 border-[#0B6A34] text-[#0B6A34]"
      : "text-[#243028] hover:text-[#0B6A34]"
  }`;

export default function SiteHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { company } = useSiteContent();
  const [open, setOpen] = useState(false);

  useEffect(() => {
    setOpen(false);
  }, [location.pathname]);

  return (
    <header className="site-theme fixed inset-x-0 top-0 z-50 h-28 border-b border-[#e4eee7] bg-white">
      <div className="flex h-8 items-center bg-[#0B6A34] text-[11px] text-white sm:text-xs">
        <div className="container-page flex items-center gap-3">
          <a href={company.phoneHref} className="truncate font-medium hover:underline">
            Cargo helpline: {company.phone}
          </a>
          <a href={company.emailHref} className="hidden truncate hover:underline sm:inline">
            {company.email}
          </a>
          <span className="ml-auto flex shrink-0 items-center gap-3">
            <a
              href={company.busWebsiteHref}
              target="_blank"
              rel="noreferrer"
              className="hidden hover:underline md:inline"
            >
              Looking for bus tickets? {company.busWebsite}
            </a>
            <a
              href={company.busWebsiteHref}
              target="_blank"
              rel="noreferrer"
              className="hover:underline md:hidden"
            >
              Bus tickets
            </a>
          </span>
        </div>
      </div>

      <div className="container-page flex h-20 items-center gap-3">
        <Logo className="h-10 w-auto max-w-[8.5rem] object-contain object-left sm:h-12 sm:max-w-[10.5rem]" />

        <nav className="ml-auto hidden items-center gap-5 xl:flex">
          {navLinks.map((link) => (
            <NavLink key={link.path} to={link.path} end={link.path === "/"} className={linkClass}>
              {link.name}
            </NavLink>
          ))}
        </nav>

        <div className="ml-auto hidden items-center gap-2 xl:ml-4 xl:flex">
          <NavLink
            to="/track-shipment"
            className="rounded-md border border-[#0B6A34] px-3.5 py-2 text-sm font-semibold text-[#0B6A34] hover:bg-[#eef6f0]"
          >
            Track Consignment
          </NavLink>
          <button
            type="button"
            onClick={() => navigate("/login")}
            className="rounded-md bg-[#6fbf45] px-3.5 py-2 text-sm font-semibold text-white hover:bg-[#5eaa38]"
          >
            Login
          </button>
        </div>

        <button
          type="button"
          onClick={() => setOpen((value) => !value)}
          className="ml-auto inline-flex h-10 w-10 items-center justify-center rounded-md text-[#0B6A34] xl:hidden"
          aria-label={open ? "Close menu" : "Open menu"}
          aria-expanded={open}
        >
          <Icon name={open ? "close" : "menu"} className="h-6 w-6" />
        </button>
      </div>

      {open && (
        <div className="absolute inset-x-0 top-full border-t border-[#e4eee7] bg-white shadow-lg xl:hidden">
          <nav className="container-page flex flex-col gap-1 py-3">
            {navLinks.map((link) => (
              <NavLink
                key={link.path}
                to={link.path}
                end={link.path === "/"}
                className={({ isActive }) =>
                  `rounded-md px-3 py-3 text-sm font-semibold ${
                    isActive ? "bg-[#eef6f0] text-[#0B6A34]" : "text-[#243028]"
                  }`
                }
              >
                {link.name}
              </NavLink>
            ))}
            <NavLink to="/track-shipment" className="rounded-md px-3 py-3 text-sm font-semibold text-[#0B6A34]">
              Track Consignment
            </NavLink>
            <button
              type="button"
              onClick={() => navigate("/login")}
              className="rounded-md px-3 py-3 text-left text-sm font-semibold text-[#0B6A34]"
            >
              Login
            </button>
          </nav>
        </div>
      )}
    </header>
  );
}
